import React from 'react';
import { styled } from '@glitz/react';
import { Grid12x12 } from 'Shared/Icons/Grid';
import { List12x12 } from 'Shared/Icons/List';
import { SolidButton, ButtonTheme } from 'Shared/TextButtons';

const GridIcon = styled(Grid12x12, {
  justifyItems: 'center',
})

const ListIcon = styled(List12x12, {
  justifyItems: 'center'
})

const GridOrListSelector = (props: {
  gridLayout: boolean;
  setGridLayout: (gridLayout: boolean) => void;
  isCompact: boolean;
}) => (
  <>
    <SolidButton
      text={''}
      onClick={() => props.setGridLayout(true)}
      theme={ButtonTheme.BlackToWhite}
      iconBefore={<GridIcon />}
      padding={{ x: props.isCompact ? 14 : 18 }}
    />
    <SolidButton
      text={''}
      onClick={() => props.setGridLayout(false)}
      theme={ButtonTheme.WhiteToBlack}
      iconBefore={<ListIcon />}
      padding={{ x: props.isCompact ? 14 : 18 }}
    />
  </>
);

export default GridOrListSelector;